import marked from 'marked/lib/marked' // https://github.com/markedjs/marked/issues/1585
import DOMPurify from 'dompurify'
import { parseLegacyLink } from 'Utilities/index'
import { safeTagsReplace } from 'Utilities/dom'

const renderer = new marked.Renderer()

renderer.link = (href, title, text) => {
  if (href.match(/{.*}/)) {
    return parseLegacyLink(href)
  } else {
    return `<a target="_blank" href="${href}">${text}</a>`
  }
}

export const markdownToHtml = (value) => {
  if (!value) return ''

  const sanitizer = (str) => DOMPurify.sanitize(safeTagsReplace(str))

  return marked(value, {
    renderer,
    sanitize: true,
    sanitizer,
    breaks: true,
    gfm: true
  })
}
